'use strict';
module.exports = function goldFileFilter(list, filter, exludeFiles, doInvert) {
	if (!list) {
		return list || [];
	}
	const filterNames = (filter && typeof filter === 'string') ? [filter] : filter,
		excludeURLs = (exludeFiles && exludeFiles.map(x => x.url)) || [];
	if (!filter || filter === 'default') {
		return list.filter((item) => {
			return item && item.context && !item.context.recycleBin  && (!item.tags || !item.tags.length) && !excludeURLs.includes(item.url);
		});
	} else if (filter === 'allMaps') {
		return list.filter((item) => {
			return item && item.context && !item.context.recycleBin && !excludeURLs.includes(item.url);
		});
	} else if (filter === 'recycleBin') {
		return list.filter((item) => {
			return item && item.context && item.context.recycleBin && !excludeURLs.includes(item.url);
		});
	}
	return list.filter(item => !(item && item.context && item.context.recycleBin))
	.filter(item => !(excludeURLs.includes(item.url)))
	.filter(item => {
		let exclude = false;
		filterNames.forEach(filterName => {
			exclude = exclude || !(item && item.context && item.context[filterName]);
		});
		if (doInvert) {
			return exclude;
		}
		return !exclude;

	});
	// return list.filter((item) => {
	// 	let include = !excludeURLs.includes(item.url);
	// 	filterNames.forEach(filterName => {
	// 		include = include && item && item.context && item.context[filterName];
	// 	});
	// 	if (doInvert) {
	// 		return !include && item && item.context && !item.context.recycleBin;
	// 	}
	// 	return include;
	// });
};
